import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxTreeSelectModule } from 'ngx-tree-select';

import { SharedModule } from '../../shared';
import { MessageModule } from '../../shared/message/message.module';
import { HomeMaterialModule } from '../home-material/home-material.module';
import { CreatePromoSavedGuard } from '../../core/services/create-promo-saved.guard';

import { ManageActivitiesComponent } from './manage-activities.component';


import { ConfirmationDialogSubmitPromo } from './create-promotions/confirmation-dialog-submit-promo';
import { DataListDialog } from './create-promotions/data-list-dialog';
import { DownloadFileFormatDialog } from './create-promotions/download-file-format-dialog';
import { SalesChallengeCardComponent } from '../components/sales-challenge-card/sales-challenge-card.component';

import {
  CreatePromotionsComponent,
} from './create-promotions/create-promotions.component';
import { OrderBy } from './create-promotions/sort-by.pipe';
import { BudgetCapRegionalTableComponent } from './create-promotions/budget-cap-regional-table/budget-cap-regional-table.component';
import { DownloadExcelModalComponent } from './create-promotions/download-excel-modal/download-excel-modal.component';
import { PromoSummaryReviewComponent } from './create-promotions/promo-summary-review/promo-summary-review.component';
import { PromoChatProgressPanelComponent } from './create-promotions/promo-chat-progress-panel/promo-chat-progress-panel.component';
import {
  CreatePromotionRulesComponent,
  ProductListDialog,
  DownloadFileFormatPromoRulesDialog,
} from './create-promotion-rules/create-promotion-rules.component';
import { PromoRuleItemComponent } from './create-promotion-rules/promo-rule-item/promo-rule-item.component';
import { ApprovaltrackerDialogComponent } from './approvaltracker-dialog/approvaltracker-dialog.component';
import { QuizChallengeComponent } from './quiz-challenge/quiz-challenge.component';
import { AddNewActivityChallengeComponent } from './add-new-activity-challenge/add-new-activity-challenge/add-new-activity-challenge.component';
import { ParticipationChallengeComponent } from './participation-challenge/participation-challenge.component';
import { ProductBookingChallengeComponent } from './product-booking-challenge/product-booking-challenge.component';
import { CreateLeaderboardChallengeComponent } from './leader-board-challenge/create-leaderboard-challenge/create-leaderboard-challenge.component';
import { ViewLeaderboardChallengeComponent } from './leader-board-challenge/view-leaderboard-challenge/view-leaderboard-challenge.component';
import { ViewLeaderboardCardsComponent } from './leader-board-challenge/view-leaderboard-cards/view-leaderboard-cards.component';
import { ApprovalTrackerModalComponent } from './approval-tracker-modal/approval-tracker-modal.component';
import { FinalizeChallengeModalComponent } from './finalize-challenge-modal/finalize-challenge-modal.component';
import { DownloadFileModalComponent } from './download-file-modal/download-file-modal.component';
import { StandardIncentivesComponent } from './sales-challenges-incentives/standard-incentives/standard-incentives.component';
import { BonusIncentivesComponent } from './sales-challenges-incentives/bonus-incentives/bonus-incentives.component';
import { ManageBudgetComponent } from './manage-budget/manage-budget.component';
import { BookingChallengeFormComponent } from './booking-challenge-form/booking-challenge-form.component';
import { ArchitectureChallengeFormComponent } from './architecture-challenge-form/architecture-challenge-form.component';
import { TrainingChallengeFormComponent } from './training-challenge-form/training-challenge-form.component';
import { CiscoAdminCreateChallengeComponent } from './cisco-admin-create-challenge/cisco-admin-create-challenge.component';
import { LeaderCreateChallengeComponent } from './leader-create-challenge/leader-create-challenge.component';
import { CiscoAdminBudgetCapTabComponent } from './cisco-admin-budgetcap-tab/cisco-admin-budgetcap-tab.component';
import { SalesChallengeListComponent } from './sales-challenge-list/sales-challenge-list.component';
import { BudgetCapManagementComponent } from './budget-cap-management/budget-cap-management.component';
import { ActivityTabComponent } from './activity-tab/activity-tab.component';
import { SalesTabComponent } from './sales-tab/sales-tab.component';
import { PromotionsTabComponent } from './promotions-tab/promotions-tab.component';
import { LeaderboardTabComponent } from './leaderboard-tab/leaderboard-tab.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxTreeSelectModule.forRoot({
      allowFilter: true,
      filterPlaceholder: 'Search',
      maxVisibleItemCount: 5,
      idField: 'id',
      textField: 'name',
      childrenField: 'children',
      allowParentSelection: false,
      expandMode: 'Selection ',
    }),
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatMomentDateModule,
    DragDropModule,
    AngularEditorModule,
    ImageCropperModule,
    HomeMaterialModule,
    MessageModule,
    SharedModule,
  ],
  declarations: [
    ManageActivitiesComponent,
    CreatePromotionsComponent,
    ConfirmationDialogSubmitPromo,
    DataListDialog,
    DownloadFileFormatDialog,
    OrderBy,
    BudgetCapRegionalTableComponent,
    DownloadExcelModalComponent,
    PromoSummaryReviewComponent,
    PromoChatProgressPanelComponent,
    CreatePromotionRulesComponent,
    PromoRuleItemComponent,
    ProductListDialog,
    DownloadFileFormatPromoRulesDialog,
    ApprovaltrackerDialogComponent,
    QuizChallengeComponent,
    AddNewActivityChallengeComponent,
    ParticipationChallengeComponent,
    ProductBookingChallengeComponent,
    CreateLeaderboardChallengeComponent,
    ViewLeaderboardChallengeComponent,
    ViewLeaderboardCardsComponent,
    ApprovalTrackerModalComponent,
    FinalizeChallengeModalComponent,
    DownloadFileModalComponent,
    StandardIncentivesComponent,
    BonusIncentivesComponent,
    ManageBudgetComponent,
    BookingChallengeFormComponent,
    ArchitectureChallengeFormComponent,
    TrainingChallengeFormComponent,
    CiscoAdminCreateChallengeComponent,
    LeaderCreateChallengeComponent,
    CiscoAdminBudgetCapTabComponent,
    SalesChallengeListComponent,
    BudgetCapManagementComponent,
    SalesChallengeCardComponent,
    ActivityTabComponent,
    SalesTabComponent,
    PromotionsTabComponent,
    LeaderboardTabComponent,
  ],
  exports: [
    ManageActivitiesComponent,
    SalesChallengeCardComponent,
    ViewLeaderboardCardsComponent,
  ],
  entryComponents: [
    ConfirmationDialogSubmitPromo,
    DataListDialog,
    DownloadFileFormatDialog,
    ProductListDialog,
    DownloadFileFormatPromoRulesDialog,
    ApprovaltrackerDialogComponent,
  ],
  providers: [
    CreatePromoSavedGuard,
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA,
  ],
})
export class ManageActivitiesModule {}
